import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionGetPlanAssignmentsPathParameters } from 'api/actions/revision-get-plan-assignments/revision-get-plan-assignments-path-parameters';
import { RevisionGetPlanAssignmentsResponse } from 'api/actions/revision-get-plan-assignments/revision-get-plan-assignments-response';

type RevisionGetPlanAssignmentsQueryParameters = Record<string, any>;

/**
 * The path of the RevisionGetPlanAssignments action.
 */
export const revisionGetPlanAssignmentsActionPath = new SweetPath<keyof RevisionGetPlanAssignmentsPathParameters>(
  '/api/revision/plan-assignments/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionGetPlanAssignments actions.
 */
export default function createRevisionGetPlanAssignmentsAction(axios: AxiosInstance) {
  return function revisionGetPlanAssignmentsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionGetPlanAssignmentsPathParameters;
    query?: RevisionGetPlanAssignmentsQueryParameters;
  }) {
    const path = revisionGetPlanAssignmentsActionPath.insert(parameters);

    return axios.request<RevisionGetPlanAssignmentsResponse, RevisionGetPlanAssignmentsResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
